<style lang="less" rel="stylesheet/less" scope>
.wrapper {
  height: 90px;
  background: url('./../../assets/homepage/headbg.png') right repeat-y;
  background-color: #00a0e8;
  .container {
    max-width: 1200px;
    min-width: 1000px;
    padding: 0 25px;
    height: 90px;
    line-height: 90px;
    margin: 0 auto;
    color: #ffffff;
    .left {
      display: inline-block;
      h3 {
        display: inline-block;
        padding-right: 15px;
        font-size: 20px;
        font-weight: 600;
      }
      img {
        vertical-align: middle;
      }
    }
    .right {
      font-weight: 600;
      font-size: 14px;
      a {
        text-decoration: none;
        i {
          padding-right: 6px;
        }
        &:active,
        &:hover,
        &:visited,
        &:link {
          color: inherit;
        }
        &.right-info {
          padding-right: 14px;
          &:last-child {
            padding: 0;
          }
        }
      }
      span {
        padding-right: 14px;
      }
    }
  }
  section {
    position: relative;
    overflow: hidden;
    background-size: contain;
    background: url('./../../assets/homepage/bg.jpg') center no-repeat;
    background-size: cover;
    .animation-cloud(@top,@left,@width,@heigth,@url,@keyframes-run,@time) {
      position: absolute;
      top: @top;
      left: @left;
      width: @width;
      height: @heigth;
      background: url(@url) center no-repeat;
      animation: @keyframes-run @time linear infinite alternate;
      -moz-animation: @keyframes-run @time linear infinite alternate;
      -webkit-animation: @keyframes-run @time linear infinite alternate;
      -o-animation: @keyframes-run @time linear infinite alternate;
    }
    .cloud-wrapper-one {
      .animation-cloud(
        400px,
        0,
        650px,
        360px,
        './../../assets/homepage/cloud1.png',
        cloudleft,
        65s
      );
    }
    .cloud-wrapper-two {
      .animation-cloud(
        100px,
        600px,
        580px,
        300px,
        './../../assets/homepage/cloud2.png',
        cloudright,
        65s
      );
    }
    @keyframes cloudleft {
      from {
        left: 0;
      }
      to {
        left: 100%;
      }
    }
    @keyframes cloudright {
      from {
        left: 600px;
      }
      to {
        left: 100%;
      }
    }
    .section-wrapper {
      width: 1260px;
      margin: 0 auto;
      .main-wrapper {
        position: relative;
        .app-items-wrapper {
          margin: 150px auto 0;
          .app-items {
            float: left;
            width: 180px;
            height: 202px;
            .app {
              display: block;
              text-align: center;
              cursor: pointer;
              &:hover {
                img {
                  transform: scale(1.1);
                  -webkit-transform: scale(1.1);
                  -moz-transform: scale(1.1);
                  -o-transform: scale(1.1);
                  -ms-transform: scale(1.1);
                  opacity: 0.8;
                  box-shadow: 0 2px 16px #bec2cd, 0 0 1px #bec2cd,
                    0 0 1px #bec2cd;
                }
              }
            }
            img {
              display: inline-block;
              width: 120px;
              height: 120px;
              border-radius: 20px;
              transition: All 0.3s ease-in-out;
              -webkit-transition: All 0.3s ease-in-out;
              -moz-transition: All 0.3s ease-in-out;
              -o-transition: All 0.3s ease-in-out;
            }
            h4 {
              margin: 18px 0 30px;
              font-family: 'Microsoft Yahei';
              font-weight: bold;
              font-size: 20px;
              color: #555555;
              text-align: center;
              span {
                display: inline-block;
                padding: 0 10px;
              }
            }
          }
        }
      }
    }
  }
  .change-email-wrapper {
    height: 150px;
    background-color: #ffffff;
    .header {
      background-color: #00a1e9;
      p {
        display: inline-block;
      }
      i {
        padding-right: 5px;
        color: #ffffff;
      }
      .top-nav-header .top-nav-info span,
      a {
        color: #ffffff;
      }
    }
  }
}

@media screen and (max-width: 1260px) {
  .wrapper {
    .header-wrapper .container {
      width: 940px;
    }
    section {
      .section-wrapper {
        width: 960px;
        .main-wrapper {
          .app-items-wrapper {
            width: 320px;
            .app-items {
              width: 160px;
              height: 177px;
              img {
                width: 100px;
                height: 100px;
                border-radius: 12px;
              }
              h4 {
                margin-top: 16px;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 900px) {
  .wrapper {
    .header-wrapper .header .left h3 {
      font-size: 16px;
    }
  }
}
</style>
<template>
  <div>
    <div class="wrapper" v-if="userInfo.loginDate && userInfo.email&&appList.length > 1">
      <div class="container" ref="header">
        <div class="left">
          <h3>{{api.PLATFORM_NAME?api.PLATFORM_NAME:'教育装备管理公共服务平台'}}</h3>
          <img src="./../../assets/login/log.png" alt />
        </div>
        <div class="right pull-right">
          欢迎您：
          <span v-text="userInfo.name"></span>
          <router-link :to="{name: 'index'}" class="right-info">
            <i class="el-icon-fa-user-circle"></i>用户中心
          </router-link>
          <!-- <a
            href="javascript:;"
            class="right-info"
            v-if="$store.getters.userInfo.simulate == 1"
            @click="cancel"
          >
            <i class="el-icon-fa-sign-out"></i>注销
          </a> -->
          <a href="javascript:;" class="right-info" @click="logout">
            <i class="el-icon-fa-power-off"></i>退出
          </a>
        </div>
      </div>
      <section class="clearfix" v-bind:style="{'height': (windowHeight - 90) + 'px'}">
        <div class="cloud-wrapper-one"></div>
        <div class="cloud-wrapper-two"></div>
        <div class="section-wrapper">
          <div class="main-wrapper clearfix">
            <div class="app-items-wrapper clearfix" :style="{'width': appWidth}">
              <template v-for="items in appList">
                <div class="app-items" v-if="items.id!=3" :key="items.id">
                  <a :href="items.url?items.url:''" class="app">
                    <ly-default-image :src="items.img" :id="items.id"></ly-default-image>
                    <h4 class="item-title">
                      <span>{{items.name}}</span>
                    </h4>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
      <ly-customer-board></ly-customer-board>
      <div v-if="dialogValue" class="smallIconOver" @mouseenter="notifyAuth">
        <img src="./../../assets/login/btn-dialog.png" />
      </div>
      <!-- 多个应用的到期通知显示 -->
      <div class="message-auth-platform">
        <el-dialog
          :visible.sync="notification"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          title="服务到期通知"
          :modal="false"
          :before-close="handleDialogClose"
          style="white-space:pre-line;word-wrap: break-word; line-height:25px;"
        >
          <AuthMsg :msg="dialogValue" />
        </el-dialog>
      </div>
    </div>
    <!-- 系统权限过期提醒 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="服务到期通知"
      class="dialog-auth-platform"
    >
      <AuthMsg :msg="dialogValue" />
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="timeDalay>0" type="primary" size="small" @click="handleDialog">预计阅读时间（{{ timeDalay }}s）</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type='text/ecmascript-6'>
import { Notification } from 'element-ui';
import defaultImage from '@/components/default-image/index';
import customerBoard from '@/components/customer-board';
import store from '@/store';
import logOutMixin from '@/components/layout/logout-mixin';
import { logout } from '@/utils/logout';
import { mapState } from 'vuex';
import { checkAuthApp } from '@/api/getApp.js';
import AuthMsg from './auth-msg.vue';
import { setInterval } from 'timers';

export default {
  components: {
    defaultImage,
    customerBoard,
    AuthMsg
  },
  mixins: [logOutMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.query.cancel) {
        next({ name: 'users' });
        return false;
      }
      checkAuthApp().then(auth => {
        if (auth.data && auth.data[0]) {
          if(from.name === "login"){
            vm.dialogVisible = true;
          }else{
            vm.handleApp(vm, next);
          }
          vm.dialogValue = auth.data[0];
        } else {
          vm.handleApp(vm, next);
        }
      });
    });
  },
  data: () => ({
    notification: false,
    dialogVisible: false,
    timeDalay: 15,
    dialogValue: '',
    userInfo: {
      name: ''
    },
    appList: [],
    windowHeight: document.documentElement.clientHeight
  }),
  computed: {
    ...mapState({ api: state => state.api }),
    iportalGlobalURL() {
      return this.api.BASE_API;
    },
    appWidth() {
      return this.setAppWidth(this.appList.length) + 'px';
    }
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.timeDalay <= 1) {
        clearInterval(timer);
        if(this.dialogVisible){
          this.handleApp(this, this.$router.push);
        }
        this.dialogVisible = false;
      }      
      if (this.dialogVisible) {
        this.timeDalay--;
      }
    }, 1000);
  },
  methods: {
    /**
     * 1. 首次登录，需要修改密码
     * 2. 应用只有一个，直接进入应用
     * 3. 多个应用时，进入平台路由
     */
    handleApp(vm, next) {
      store.dispatch('GetInfo').then(res => {
        if (res.loginDate && res.email) {
          vm.getAppList().then(app => {
            if (app.length == 0) {
              localStorage.IPORTAL = true;
              next('/index');
            } else if (app.length == 1) {
              if (app[0].url == null || app[0].url.includes('iportal')) {
                next('/index');
              } else {
                localStorage.OA = 'TRUE';
                window.location.href = app[0].url + '?onlyApp';
              }
            } else {
              next('/platform');
            }
          });
          vm.userInfo = store.getters.userInfo;
        } else {
          vm.$message({
            message: '首次登录，请修改密码。',
            type: 'warning',
            duration: 2000,
            showClose: false,
            onClose: function() {
              vm.$router.push({
                name:'change_email'
              })
              // next('/change_email');
            }
          });
        }
      });
    },
    handleDialog() {
      this.handleApp(this, this.$router.push);
    },
    getAppList() {
      return new Promise((resolve, reject) => {
        store.dispatch('GetPlatFormApp').then(res => {
          let appList = res;
          if (appList != null) {
            for (let i in appList) {
              var id = appList[i].id;
              if (id != 3) {
                if (id == 10) {
                  var token = store.getters.token;
                  appList[i].url +=
                    '?access_token=' +
                    token.access_token +
                    '&token_type=' +
                    token.token_type +
                    '&expires_in=' +
                    token.expires_in;
                }
                this.appList.push(appList[i]);
              }
            }
            resolve(this.appList);
          } else {
            this.$confirm('您还未拥有权限进入应用系统', '温馨提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'warning'
            })
              .then(() => {
                logout();
              })
              .catch(() => {
                logout();
              });
            reject();
          }
        });
      });
    },
    setAppWidth(len) {
      if (window.innerWidth > 1260) {
        if (len > 5) {
          if (len % 2 == 0) {
            return (len / 2) * 180;
          } else {
            return ((len + 1) / 2) * 180;
          }
        } else {
          return len * 180;
        }
      } else {
        if (len > 5) {
          if (len % 2 == 0) {
            return (len / 2) * 160;
          } else {
            return ((len + 1) / 2) * 160;
          }
        } else {
          return len * 160;
        }
      }
    },
    notifyAuth() {
      console.log('herong');
      this.notification = true;
    },
    handleDialogClose() {
      this.notification = false;
    }
  }
};
</script>
<style lang="less" scoped>
.auth-item {
  text-indent: 27px;
  margin-bottom: 10px;
}
.smallIconOver {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 36px;
  height: 36px;
  line-height: 40px;
  background: #409eff;
  text-align: center;
  cursor: pointer;
}
</style>
<style lang="less">
.dialog-auth-platform {
  .el-dialog--small {
    width: 600px;
  }
}
.message-auth-platform {
  .el-dialog__wrapper {
    width: 0;
    height: 0;
  }
  .el-dialog {
    position: fixed;
    bottom: 10px;
    left: auto;
    right: 10px;
    top: auto !important;
    margin: 0 auto;
  }
  .el-dialog--small {
    width: 600px;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .el-dialog__header {
    background-color: #409eff;
    padding: 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/platform/platform.vue